import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi, ghsApi } from '../config/axios';

import {
    FETCH_DEVICE_LIST,
    FETCH_DEVICE_LIST_SUCCESS,
    FETCH_DEVICE_LIST_FAIL,
    FETCH_REGISTERED_DEVICE_LIST,
    FETCH_REGISTERED_DEVICE_LIST_FETCHING,
    FETCH_REGISTERED_DEVICE_LIST_SUCCESS,
    FETCH_REGISTERED_DEVICE_LIST_FAIL,
    FETCH_DEVICE_INFO,
    FETCH_DEVICE_INFO_START,
    FETCH_DEVICE_INFO_SUCCESS,
    FETCH_DEVICE_INFO_FAIL,
    FETCH_USER_DEVICE_INFO,
    FETCH_USER_DEVICE_INFO_START,
    FETCH_USER_DEVICE_INFO_SUCCESS,
    FETCH_USER_DEVICE_INFO_FAIL,
    FETCH_REGISTERED_DEVICES,
    FETCH_GEAR,
    FETCH_DEVICE_INFO_BY_PART_NUMBER,
    FETCH_DEVICE_INFO_BY_PART_NUMBER_START,
    FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS,
    FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL,
    FETCH_PRIMARY_TRAINING_DEVICE,
    FETCH_PRIMARY_TRAINING_DEVICE_START,
    FETCH_PRIMARY_TRAINING_DEVICE_FAIL,
    FETCH_PRIMARY_TRAINING_DEVICE_SUCCESS,
    FETCH_DEVICE_BETA_SOFTWARE_INFO,
    FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING,
    FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS,
    FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL,
    UPDATE_PRIMARY_TRAINING_DEVICE,
    UPDATE_PRIMARY_TRAINING_DEVICE_START,
    UPDATE_PRIMARY_TRAINING_DEVICE_FAIL,
    UPDATE_PRIMARY_TRAINING_DEVICE_SUCCESS,
    UPDATE_PRIMARY_ACTIVITY_TRACKER,
    UPDATE_PRIMARY_ACTIVITY_TRACKER_START,
    UPDATE_PRIMARY_ACTIVITY_TRACKER_FAIL,
    UPDATE_PRIMARY_ACTIVITY_TRACKER_SUCCESS,
    REMOVE_DEVICE,
    REMOVE_DEVICE_START,
    REMOVE_DEVICE_FAIL,
    REMOVE_DEVICE_SUCCESS,
    FETCH_HISTORICAL_DEVICE_LIST_FETCHING,
    FETCH_HISTORICAL_DEVICE_LIST_SUCCESS,
    FETCH_HISTORICAL_DEVICE_LIST_FAIL,
    FETCH_HISTORICAL_DEVICE_LIST,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL
} from '../actions/ActionTypes';
import { requestRegisteredDevices, receiveRegisteredDevices, requestGear, receiveGear } from '../actions';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

// Workers
export function* fetchDeviceListSaga(action) {
    const { displayName } = action;

    try {
        const response = yield call(gcApi.get, `/device-service/deviceservice/device-info/all/${displayName}`);

        yield put({
            type: FETCH_DEVICE_LIST_SUCCESS,
            deviceList: response.data,
            displayName: displayName
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_LIST_FAIL,
            deviceList: [],
            displayName: displayName
        });
    }
}

export function* fetchRegisteredDeviceListSaga() {
    try {
        yield put({
            type: FETCH_REGISTERED_DEVICE_LIST_FETCHING
        });

        const response = yield call(gcApi.get, `/device-service/deviceregistration/devices`);

        yield put({
            type: FETCH_REGISTERED_DEVICE_LIST_SUCCESS,
            registeredDeviceList: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_REGISTERED_DEVICE_LIST_FAIL,
            registeredDeviceList: []
        });
    }
}

export function* fetchHistoricalDeviceListSaga() {
    try {
        yield put({
            type: FETCH_HISTORICAL_DEVICE_LIST_FETCHING
        });

        const response = yield call(gcApi.get, `/device-service/deviceregistration/devices/historical`);
        yield put({
            type: FETCH_HISTORICAL_DEVICE_LIST_SUCCESS,
            historicalDeviceList: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_HISTORICAL_DEVICE_LIST_FAIL,
            historicalDeviceList: null
        });
    }
}

export function* fetchDeviceInfoSaga(action) {
    const { deviceId } = action.payload;

    try {
        yield put({
            type: FETCH_DEVICE_INFO_START
        });

        const response = yield call(gcApi.get, `/device-service/deviceservice/app-info/device/${deviceId}`);

        yield put({
            type: FETCH_DEVICE_INFO_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_INFO_FAIL,
            data: null
        });
    }
}

export function* fetchDeviceInfoByDeviceVersionPkSaga(action) {
    const { deviceId } = action.payload;

    try {
        yield put({
            type: FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START
        });

        const response = yield call(gcApi.get, `/device-service/deviceservice/app-info/${deviceId}`);

        yield put({
            type: FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL,
            data: null
        });
    }
}

export function* fetchUserDeviceInfoSaga(action) {
    const { deviceId } = action.payload;

    try {
        yield put({
            type: FETCH_USER_DEVICE_INFO_START
        });

        const response = yield call(gcApi.get, `/device-service/deviceservice/user-device/${deviceId}`);

        yield put({
            type: FETCH_USER_DEVICE_INFO_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_DEVICE_INFO_FAIL,
            data: null
        });
    }
}

export function* fetchRegisteredDevices({ displayName }) {
    try {
        yield put(requestRegisteredDevices(displayName));

        const response = yield gcApi.get(`/device-service/deviceregistration/devices/all/${displayName}`);

        yield put(receiveRegisteredDevices(displayName, response.data));
    } catch (e) {}
}

export function* fetchGearSaga({ displayName }) {
    try {
        yield put(requestGear(displayName));
        const response = yield gcApi.get(`/device-service/deviceservice/userlastused/${displayName}`);
        yield put(receiveGear(displayName, response.data));
    } catch (e) {}
}

export function* fetchDeviceInfoByPartNumberSaga(action) {
    const { partNumber } = action.payload;

    try {
        yield put({
            type: FETCH_DEVICE_INFO_BY_PART_NUMBER_START
        });

        const response = yield call(gcApi.get, `/device-service/devicelist/devices?partNumber=${partNumber}`);

        yield put({
            type: FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL,
            data: null
        });
    }
}

export function* fetchDeviceByHealthDeviceId(action) {
    const { healthDeviceId } = action.payload;

    try {
        yield put({
            type: FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START
        });

        const response = yield call(ghsApi.get, `/ghs/account/v1/device/${healthDeviceId}/all`);

        yield put({
            type: FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL,
            data: null
        });
    }
}

export function* fetchPrimaryTrainingDevice({ userId }) {
    try {
        yield put({
            type: FETCH_PRIMARY_TRAINING_DEVICE_START,
            userId
        });
        const response = yield call(gcApi.get, `/web-gateway/device-info/primary-training-device`);
        yield put({
            type: FETCH_PRIMARY_TRAINING_DEVICE_SUCCESS,
            userId,
            data: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {
        yield put({
            type: FETCH_PRIMARY_TRAINING_DEVICE_FAIL,
            data: null
        });
    }
}

export function* fetchDeviceBetaSoftwareInfoSaga({
    deviceId,
    partNumber,
    currentFirmwareVersionMajor,
    currentFirmwareVersionMinor
}) {
    try {
        yield put({
            type: FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/web-gateway/pbs-gateway/pbs-info/device-id/${deviceId}/part-number/${partNumber}/major-version/${currentFirmwareVersionMajor}/minor-version/${currentFirmwareVersionMinor}`
        );

        yield put({
            type: FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS,
            deviceId: deviceId,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL,
            deviceId: deviceId,
            data: {}
        });
    }
}

export function* updatePrimaryTrainingDevice({ userId, deviceId, callback }) {
    try {
        yield put({
            type: UPDATE_PRIMARY_TRAINING_DEVICE_START,
            userId,
            deviceId
        });
        const response = yield call(
            gcApi.put,
            `/userprofile-service/userprofile/user-settings/primary-training-device`,
            { deviceId }
        );
        yield call(handlingSuccessCallback, callback, response);
        yield put({
            type: UPDATE_PRIMARY_TRAINING_DEVICE_SUCCESS,
            deviceId,
            data: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
        yield put({
            type: UPDATE_PRIMARY_TRAINING_DEVICE_FAIL,
            data: null
        });
    }
}

export function* updatePrimaryActivityTracker({ userId, deviceId, callback }) {
    try {
        yield put({
            type: UPDATE_PRIMARY_ACTIVITY_TRACKER_START,
            userId,
            deviceId
        });
        const response = yield call(
            gcApi.put,
            `device-service/deviceservice/device-info/${deviceId}/primary-activity-tracker`
        );
        yield call(handlingSuccessCallback, callback, response);
        yield put({
            type: UPDATE_PRIMARY_ACTIVITY_TRACKER_SUCCESS,
            deviceId,
            data: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
        yield put({
            type: UPDATE_PRIMARY_ACTIVITY_TRACKER_FAIL,
            data: null
        });
    }
}

export function* removeDevice({ deviceId, callback }) {
    try {
        yield put({
            type: REMOVE_DEVICE_START,
            deviceId
        });
        const response = yield call(gcApi.delete, `device-service/deviceregistration/device/${deviceId}`);
        yield put({
            type: REMOVE_DEVICE_SUCCESS,
            deviceId,
            data: response.data,
            receivedAt: Date.now()
        });
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
        yield put({
            type: REMOVE_DEVICE_FAIL,
            data: null
        });
    }
}

// Watchers
export const deviceSagas = [
    takeEvery(FETCH_DEVICE_LIST, fetchDeviceListSaga),
    takeEvery(FETCH_REGISTERED_DEVICE_LIST, fetchRegisteredDeviceListSaga),
    takeEvery(FETCH_DEVICE_INFO, fetchDeviceInfoSaga),
    takeEvery(FETCH_USER_DEVICE_INFO, fetchUserDeviceInfoSaga),
    takeEvery(FETCH_REGISTERED_DEVICES, fetchRegisteredDevices),
    takeEvery(FETCH_GEAR, fetchGearSaga),
    takeEvery(FETCH_DEVICE_INFO_BY_PART_NUMBER, fetchDeviceInfoByPartNumberSaga),
    takeEvery(FETCH_DEVICE_BY_HEALTH_DEVICE_ID, fetchDeviceByHealthDeviceId),
    takeEvery(FETCH_PRIMARY_TRAINING_DEVICE, fetchPrimaryTrainingDevice),
    takeEvery(FETCH_DEVICE_BETA_SOFTWARE_INFO, fetchDeviceBetaSoftwareInfoSaga),
    takeEvery(UPDATE_PRIMARY_TRAINING_DEVICE, updatePrimaryTrainingDevice),
    takeEvery(UPDATE_PRIMARY_ACTIVITY_TRACKER, updatePrimaryActivityTracker),
    takeEvery(REMOVE_DEVICE, removeDevice),
    takeEvery(FETCH_HISTORICAL_DEVICE_LIST, fetchHistoricalDeviceListSaga),
    takeEvery(FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK, fetchDeviceInfoByDeviceVersionPkSaga)
];
